import { Rate, Image, Avatar, Dropdown, Menu, Modal } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useParams } from "react-router";
import DriverLayout from "../Layout";
import DriverHeader from "../Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_DRIVER_INFO } from "../../../redux/auth/authType";
import moment from "moment";
import { DriverStatus, getImgUrl } from "../../../utils";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const { confirm } = Modal;

const DriverDetails = (): ReactElement => {
  const dispatch = useDispatch();
  const route = useParams();
  const [driverStatus, setDriverStatus] = useState<string>();
  const [changeDriverStatus, setChangeDriverStatus] = useState<string>();
  const [writeNote, setWriteNote] = useState<string>();
  const [singleDriverInfo, setSingleDriverInfo] = useState({
    loading: false,
    data: null,
  });

  const fetchDriverDetails = useCallback((getDriverId) => {
    if (getDriverId) {
      try {
        setSingleDriverInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_RIDER_API}/admin/driver/${getDriverId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleDriverInfo({
                loading: false,
                data: data?.data?.driver,
              });
              setDriverStatus(data?.data?.driver?.status);
              dispatch({
                type: SET_DRIVER_INFO,
                payload: {
                  driverInfo: {
                    image: data?.data?.driver?.profilePictureUrl,
                    name: data?.data?.driver?.name,
                    mobileNumber: data?.data?.driver?.mobileNumber,
                    balance: data?.data?.driver?.balance,
                    rating: data?.data?.driver?.rating,
                    // status: data?.data?.driver?.status,
                  },
                },
              });
            } else {
              setSingleDriverInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleDriverInfo({ loading: false, data: null });
            console.log(err);
          });
      } catch (error) {
        setSingleDriverInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  const onStatusChange = async () => {
    // if (driver?.data?.driverId && status) {
    await fetch(`${process.env.REACT_APP_RIDER_API}/driver/status`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        driverId: singleDriverInfo?.data?.id,
        status: changeDriverStatus,
        note: writeNote,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode === 200) {
          responseNotification("Status Updated Successfully", "success");
          fetchDriverDetails((route as any)?.id);
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
    // }
  };

  function showConfirm() {
    confirm({
      title: "Do you Want to change Status?",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        onStatusChange();
      },
      onCancel() {
        console.log("Cancel");
      },
      okText: "Change Status",
    });
  }

  useEffect(() => {
    fetchDriverDetails((route as any)?.id);
  }, [fetchDriverDetails, route]);

  useEffect(() => {
    if (changeDriverStatus) {
      showConfirm();
    }
  }, [changeDriverStatus]);

  const driver = singleDriverInfo?.data;

  return (
    <React.Fragment>
      <DriverLayout driverId={(route as any)?.id as string}>
        <div className="bg-white">
          <DriverHeader
            leftarea={"Driver Information"}
            rightarea={
              <Dropdown.Button
                overlay={
                  <Menu>
                    {Object?.values(DriverStatus)?.map((status, i) => (
                      <Menu.Item
                        key={status}
                        onClick={(val) => {
                          setChangeDriverStatus(val?.key);
                        }}
                      >
                        {status?.split("_").join(" ") || "Status"}
                      </Menu.Item>
                    ))}
                  </Menu>
                }
              >
                {driver?.status?.split("_").join(" ") || "Status"}
              </Dropdown.Button>
            }
          />
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Driver Name</span>
                  <span className="info-desc">{driver?.name}</span>
                </div>

                <div className="single">
                  <span className="info-name">Mobile Number</span>
                  <span className="info-desc">
                    {driver?.mobileNumber?.split("+88")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Current Balance</span>
                  <span className="info-desc">
                    &#2547; {driver?.balance || 0}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Driver ID</span>
                  <span className="info-desc">{driver?.driverId}</span>
                </div>

                {driver?.city && (
                  <div className="single">
                    <span className="info-name">City</span>
                    <span className="info-desc">{driver?.city}</span>
                  </div>
                )}

                {driver?.zone && (
                  <div className="single">
                    <span className="info-name">Zone</span>
                    <span className="info-desc">{driver?.zone}</span>
                  </div>
                )}

                {driver?.type && (
                  <div className="single">
                    <span className="info-name">Type</span>
                    <span className="info-desc">{driver?.type}</span>
                  </div>
                )}

                {driver?.vehicleType && (
                  <div className="single">
                    <span className="info-name">Vehicle Type</span>
                    <span className="info-desc">{driver?.vehicleType}</span>
                  </div>
                )}

                {driver?.personalInfoStatus && (
                  <div className="single">
                    <span className="info-name">Personal Info Status</span>
                    <span className="info-desc">
                      {driver?.personalInfoStatus}
                    </span>
                  </div>
                )}

                <div className="single">
                  <span className="info-name">Rattings</span>
                  <span className="info-desc">
                    <Rate value={driver?.rating || 0} disabled />
                    <small className="ml-1">
                      ({driver?.numberOfRating || 0})
                    </small>
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn ${driver?.status?.toLowerCase()}`}
                    >
                      {driver?.status?.split("_").join(" ")}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <span className="info-name">Joining Date</span>
                  <span className="info-desc">
                    {moment(driver?.createdAt).format("lll")}
                  </span>
                </div>

                {driver?.nid && (
                  <>
                    <h4 className="title mt-5">NID INFORMATION</h4>
                    {driver?.nid?.nidNumber && (
                      <div className="single">
                        <span className="info-name">NID</span>
                        <span className="info-desc">
                          {driver?.nid?.nidNumber}
                        </span>
                      </div>
                    )}

                    {driver?.nid && (
                      <div className="single">
                        <span className="info-name">NID Front</span>
                        <span className="info-desc">
                          <Avatar
                            shape="square"
                            size={100}
                            src={
                              <Image
                                src={getImgUrl(driver?.nid?.frontUrl)}
                                height={100}
                              />
                            }
                            className="mr-3"
                          />
                        </span>
                      </div>
                    )}

                    {driver?.nid?.backUrl && (
                      <div className="single">
                        <span className="info-name">NID Back</span>
                        <span className="info-desc">
                          <Avatar
                            shape="square"
                            size={100}
                            src={
                              <Image
                                src={getImgUrl(driver?.nid?.backUrl)}
                                height={100}
                              />
                            }
                            className="mr-3"
                          />
                        </span>
                      </div>
                    )}
                  </>
                )}

                {driver?.drivingLicense && (
                  <>
                    <h4 className="title mt-5">Driving License</h4>
                    {driver?.drivingLicense && (
                      <div className="single">
                        <span className="info-name">Driving License</span>
                        <span className="info-desc">
                          {driver?.drivingLicense?.drivingLicenseNumber}
                        </span>
                      </div>
                    )}

                    {driver?.drivingLicense?.frontUrl && (
                      <div className="single">
                        <span className="info-name">Driving License Front</span>
                        <span className="info-desc">
                          <Avatar
                            shape="square"
                            size={100}
                            src={
                              <Image
                                src={getImgUrl(
                                  driver?.drivingLicense?.frontUrl
                                )}
                                height={100}
                              />
                            }
                            className="mr-3"
                          />
                        </span>
                      </div>
                    )}

                    {driver?.drivingLicense?.backUrl && (
                      <div className="single">
                        <span className="info-name">Driving License Back</span>
                        <span className="info-desc">
                          <Avatar
                            shape="square"
                            size={100}
                            src={
                              <Image
                                src={getImgUrl(driver?.drivingLicense?.backUrl)}
                                height={100}
                              />
                            }
                            className="mr-3"
                          />
                        </span>
                      </div>
                    )}
                  </>
                )}

                {driver?.registrationPaper && (
                  <>
                    <h4 className="title mt-5">Registration Paper</h4>

                    {driver?.registrationPaper?.frontUrl && (
                      <div className="single">
                        <span className="info-name">
                          Registration Paper Front
                        </span>
                        <span className="info-desc">
                          <Avatar
                            shape="square"
                            size={100}
                            src={
                              <Image
                                src={getImgUrl(
                                  driver?.registrationPaper?.frontUrl
                                )}
                                height={100}
                              />
                            }
                            className="mr-3"
                          />
                        </span>
                      </div>
                    )}

                    {driver?.registrationPaper?.backUrl && (
                      <div className="single">
                        <span className="info-name">
                          Registration Paper Back
                        </span>
                        <span className="info-desc">
                          <Avatar
                            shape="square"
                            size={100}
                            src={
                              <Image
                                src={getImgUrl(
                                  driver?.registrationPaper?.backUrl
                                )}
                                height={100}
                              />
                            }
                            className="mr-3"
                          />
                        </span>
                      </div>
                    )}
                  </>
                )}

                {driver?.car && (
                  <>
                    <h4 className="title mt-5">Car Information</h4>
                    {driver?.car?.carRegistrationNumber && (
                      <div className="single">
                        <span className="info-name">Registration Paper</span>
                        <span className="info-desc">
                          {driver?.car?.carRegistrationNumber}
                        </span>
                      </div>
                    )}

                    {driver?.car?.manufacturer && (
                      <div className="single">
                        <span className="info-name">Car Manufacturer</span>
                        <span className="info-desc">
                          {driver?.car?.manufacturer}
                        </span>
                      </div>
                    )}

                    {driver?.car?.model && (
                      <div className="single">
                        <span className="info-name">Car Model</span>
                        <span className="info-desc">{driver?.car?.model}</span>
                      </div>
                    )}

                    {driver?.car?.year && (
                      <div className="single">
                        <span className="info-name">Car Year</span>
                        <span className="info-desc">{driver?.car?.year}</span>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </DriverLayout>
    </React.Fragment>
  );
};
DriverDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default DriverDetails;
